export default __webpack_public_path__ + "static/media/powerful.695bb929.svg";